export default "__VITE_ASSET__63F_z$8Q__"